import cuid from "cuid";
import moment from "moment";
import { FORMAT } from "@/config/date-format";
import { SCHEDULE_TYPE } from "@/enums/schedule-type";
import { i18n } from "../main";

const dayConfig = format =>
  moment(Date.now())
    .set({ hour: "09", minute: "00", second: "00" })
    .add(1, "days")
    .format(format);
const weekConfig = format =>
  moment(Date.now())
    .set({ hour: "09", minute: "00", second: "00" })
    .add(7, "days")
    .format(format);
export default [
  {
    id: cuid(),
    name: i18n.t("message.posts.planning.publication.now"),
    type: SCHEDULE_TYPE.NOW,
    date: null,
    value: null,
    custom: false
  },
  {
    id: cuid(),
    name: i18n.t("message.posts.planning.publication.tomorrowMorning"),
    type: SCHEDULE_TYPE.NEXT_DAY,
    date: dayConfig(FORMAT.DATE_HM),
    value: dayConfig(),
    custom: false
  },
  {
    id: cuid(),
    name: i18n.t("message.posts.planning.publication.nextWeek"),
    type: SCHEDULE_TYPE.NEXT_WEEK,
    date: weekConfig(FORMAT.DATE_HM),
    value: weekConfig(),
    custom: false
  },
  {
    id: cuid(),
    name: i18n.t("message.posts.planning.publication.anotherDate"),
    type: SCHEDULE_TYPE.OTHER_DATE,
    date: null,
    value: null,
    custom: true
  }
];
